import { Injectable } from "@angular/core";

import { CoreState } from "../state";

@Injectable({
	providedIn: "root",
})
export class DialogStatusSelector {
	/**
	 * Enables to keep track of open dialogs in the application.
	 */
	hasOpenDialogs() {
		return (state: CoreState): boolean => state.dialogStatus.counter > 0;
	}

	getNumberOfOpenDialogs() {
		return (state: CoreState): number => state.dialogStatus.counter;
	}
}
